import { handleActions } from 'redux-actions';
import action from '../action';
import dState from './defaultState';
import { produce } from 'immer';
import { getSessionStorage } from '@utils/windowUtil';
import { getProjectInfoFromLocation } from '@utils/history';
import { getUrlTabMap } from '@components/directUser/data';
import { ThemeType } from '@model';

const { actionTypes } = action;
const { common } = actionTypes;

const currentId =
  getProjectInfoFromLocation()?.projectId || getSessionStorage('currentId');
const defaultState = {
  currentId: null || currentId,
  breadcrumb: [],
  shouldShowStatementFooter: true,
  config: { colors: [] },
  ...dState,
  hideScrollBar: false,
  projectCompanyInfo: {
    buyerLabel: 'Buyer',
    targetLabel: 'Target',
    spnName: null,
    permission: '',
  },
  projectInfoLoading: false,
  isReportIssueModalShown: false,
  reportIssueDefaultValue: {},
  newRoutes: '',
  spnId: null, // system level SPN ID
  settingCompanyInstance: 'Integration', // used in system setting and creating project
  banner: {
    visible: false,
    content: '',
    status: '',
  },
  urlMap: {},
  urlTabMap: {},
  systemTheme: ThemeType.light,
  systemThemeLoading: false,
  emailVerModalRef: null,
};

export default handleActions(
  {
    [common.CHANGE_LOADING]: (state, action) =>
      produce(state, (draft) => {
        draft.isLoading = action.payload;
      }),

    [common.CHANGE_CURRENT_ID_STATE]: (state, action) =>
      produce(state, (draft) => {
        if (state.currentId !== action.payload) {
          draft.currentId = action.payload;
        }
      }),
    [common.CHANGE_BREADCRUMB]: (state, action) =>
      produce(state, (draft) => {
        draft.breadcrumb = action.payload;
      }),
    [common.CHANGE_CONFIG]: (state, action) =>
      produce(state, (draft) => {
        draft.config = action.payload;
      }),
    [common.CHANGE_SHOULD_SHOW_STATEMENT]: (state, action) =>
      produce(state, (draft) => {
        draft.shouldShowStatementFooter = action.payload;
      }),
    [common.CHANGE_SCROLL_BAR]: (state, action) =>
      produce(state, (draft) => {
        draft.hideScrollBar = action.payload;
      }),

    [common.CHANGE_PROJECT_INFO]: (state, action) =>
      produce(state, (draft) => {
        draft.projectCompanyInfo = action.payload;
        draft.projectCompanyInfo.buyerLabel =
          action?.payload?.buyerLabel || 'Buyer';
        draft.projectCompanyInfo.targetLabel =
          action?.payload?.targetLabel || 'Target';
      }),
    [common.CHANGE_PROJECT_INFO_LOADING]: (state, action) =>
      produce(state, (draft) => {
        draft.projectInfoLoading = action.payload;
      }),
    [common.CHANGE_PROJECT_INSTANCE]: (state, action) =>
      produce(state, (draft) => {
        draft.projectCompanyInfo.companyInstance = action.payload;
      }),
    [common.TOGGLE_REPORT_ISSUE_MODAL]: (state, action) =>
      produce(state, (draft) => {
        draft.isReportIssueModalShown = action.payload;
      }),
    [common.CHANGE_REPORT_ISSUE_VALUES]: (state, action) =>
      produce(state, (draft) => {
        draft.reportIssueDefaultValue = action.payload;
      }),
    [common.CHANGE_ROUTES]: (state, action) =>
      produce(state, (draft) => {
        draft.newRoutes = action.payload;
      }),
    [common.CHANGE_SPN_ID]: (state, action) =>
      produce(state, (draft) => {
        draft.spnId = action.payload;
      }),
    [common.CHANGE_SETTING_COMPANY_INSTANCE]: (state, action) =>
      produce(state, (draft) => {
        draft.settingCompanyInstance = action.payload;
      }),
    [common.SHOW_BANNER]: (state, action) =>
      produce(state, (draft) => {
        draft.banner = {
          visible: true,
          ...action.payload,
        };
      }),
    [common.CLOSE_BANNER]: (state, action) =>
      produce(state, (draft) => {
        draft.banner = {
          visible: false,
          content: '',
          status: '',
        };
      }),
    [common.CHANGE_URL_MAP]: (state, action) =>
      produce(state, (draft) => {
        draft.urlMap = action.payload;
        draft.urlTabMap = getUrlTabMap(action.payload);
      }),
    [common.CHANGE_SYSTEM_THEME]: (state, action) =>
      produce(state, (draft) => {
        draft.systemTheme = action.payload;
      }),
    [common.CHANGE_SYSTEM_THEME_LOADING]: (state, action) =>
      produce(state, (draft) => {
        draft.systemThemeLoading = action.payload;
      }),

    [common.SET_EMAIL_VERIFY_MODAL_REF]: (state, action) =>
      produce(state, (draft) => {
        draft.emailVerModalRef = action.payload;
      }),
  },
  defaultState,
);
